var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`form-image-align-${_vm.align}`,attrs:{"id":"FormImage"}},[_c('img',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"src":_vm.asset}})])
}
var staticRenderFns = []

export { render, staticRenderFns }